import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-renew',
  templateUrl: './subscription-renew.component.html',
  styleUrls: ['./subscription-renew.component.scss']
})
export class SubscriptionRenewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
